import instance from "@/services/api";

export const providerAgreementListAPI = {
  async getList() {
    return await instance().get('/supplier/agreements/').then(res => res?.data)
  },
  async downloadAgreement(contractor_agreement_list_id) {
    const response = await instance().get(`/supplier/agreements/${contractor_agreement_list_id}/download/`, {
      responseType: 'blob'
    });
    return response;
  },
  async sign(contractor_agreement_list_id) {
    return await instance()
      .post(`/supplier/agreements/${contractor_agreement_list_id}/sign/`)
      .then(res => res?.data);
  },
}

